import env from "./env";
export const assetConfig = Object.freeze({
  s3BaseUrl: env.S3_BASE_URL,
  s3WhatsappBaseUrl: env.S3_WHATSAPP_BASE_URL || env.S3_BASE_URL,
  docPreviewUrl: env.DOC_PREVIEW_URL, // for Excel, Docs files
  s3BoilerplateUrl: `${env.S3_BASE_URL}/whatsapp_market_campaign/`,

  // s3BaseUrl: S3_BASE_URL,
  // docPreviewUrl: env.DOC_PREVIEW_URL, // for Excel, Docs files
  // s3BoilerplateUrl: `${S3_BASE_URL}/whatsapp_market_campaign/`
});